import './index.scss';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import phoneHeaderOption from '../../../components/dialCode.json';
import Select from 'react-select';
import { userInfo } from '../../../redux/slice';
import { useSelector } from 'react-redux';
import { get } from '../../../util/request';
import { Form } from 'antd';

export default ClientInformation; function ClientInformation({ Country, TaxFilingQuestionnaire, HandleClientInformationSave, HandleTaxFilingQuestionnaireSave }) {
    const { t } = useTranslation();
    const user = useSelector(userInfo);
    const [clientInformation, setClientInformation] = useState({ taxResidency: '', otherSourceOfIncome: '' });
    const [error, setError] = useState('');
    const [country, setCountry] = useState([]);
    const FormItem = Form.Item;
    const formRef = Form.useFormInstance();
    const viewOnly = TaxFilingQuestionnaire?.Status?.toLowerCase() !== '' && TaxFilingQuestionnaire?.Status?.toLowerCase() !== 'new';

    const handleChange = async (key, value) => {
        setClientInformation(prevData => ({
            ...prevData,
            [key]: value
        }));
    }

    useEffect(() => {
        HandleClientInformationSave(clientInformation);
    }, [clientInformation]);

    useEffect(() => {
        handleChange('taxResidency', TaxFilingQuestionnaire.CountryOfTaxResidency);
        handleChange('otherSourceOfIncome', TaxFilingQuestionnaire.OtherUSIncomeSource);
    }, []);

    const CustomPhone = ({ value, onChange, inputRequired }) => {
        const validateInput = (val) => {
            if (!val.trim()) {
                setError(t('This field is required'));
            } else {
                setError('');
            }
        };
        const handleChange = (e) => {
            onChange(value?.split(' ')[0] + ' ' + e.target.value);
            if (inputRequired) {
                validateInput(e.target.value);
            }
        };

        return (<>
            <select className='pre' value={value?.split(' ')[0] ?? ''} onChange={(e) => {
                onChange(e.target.value + ' ' + value?.split(' ')[1]);
            }} disabled={viewOnly}>
                {
                    phoneHeaderOption != null && (<>
                        {
                            phoneHeaderOption?.map((header) => (<>
                                <option value={header.dial}>{header.dial} ({header.en})</option>
                            </>))
                        }
                    </>)
                }
            </select>
            <input type='text' className='number' value={value?.split(' ')[1] ?? ''} onChange={handleChange} disabled={viewOnly} />
        </>);
    }

    return (
        <>
            <div id='stepper-client-information-div'>
                <div className='row tax-filing-questionnaire-title'>
                    <p>
                        {t('CLIENT INFORMATION')}
                    </p>
                </div>
                <div className='row stepper-client-information-content'>
                    <div className='col-md-12 row input-row'>
                        <div className='col-md-9 client-details'>
                            <div className='detail-title col-md-8'>{sessionStorage.getItem('taxYear')} {t('Tax Residency')}<i className='required'>*</i></div>
                            <div className='details col-md-4'>
                                <FormItem
                                    name="CountryOfTaxResidency"
                                    rules={[{ required: true, message: t('This field is required') }]}
                                >
                                    <select onChange={(e) => { handleChange('taxResidency', e.target.value); HandleTaxFilingQuestionnaireSave('CountryOfTaxResidency', e.target.value) }} disabled={viewOnly}>
                                        <option value=''>{t('Select Tax Residency')}</option>
                                        {
                                            Country != null && (<>
                                                {
                                                    Country?.map((item) => (<>
                                                        <option value={item.countryregionid}>{item.name}</option>
                                                    </>))
                                                }
                                            </>)
                                        }
                                    </select>
                                </FormItem>
                            </div>
                        </div>
                    </div>


                    {
                        (formRef?.getFieldValue('CountryOfTaxResidency') !== 'USA' && formRef?.getFieldValue('CountryOfTaxResidency') !== '') && (<>
                            <div className='col-md-12 row input-row'>
                                <div className='col-md-9 client-details'>
                                    <div className='detail-title col-md-8'>{t('Do you have any other source of income in U.S. other than Walton?')}</div>
                                    <div className='details col-md-4'>
                                        <FormItem
                                            name="OtherUSIncomeSource"
                                            rules={[{ required: true, message: t('This field is required') }]}
                                        >
                                            <select disabled={viewOnly} onChange={(e) => { handleChange('otherSourceOfIncome', e.target.value); HandleTaxFilingQuestionnaireSave('OtherUSIncomeSource', e.target.value) }}>
                                                <option value=''></option>
                                                <option value='Yes'>{t('Yes')}</option>
                                                <option value='No'>{t('No')}</option>
                                            </select>
                                        </FormItem>
                                    </div>
                                </div>
                            </div>

                            {
                                (formRef?.getFieldValue('OtherUSIncomeSource') !== 'Yes' && formRef?.getFieldValue('OtherUSIncomeSource') !== '') && (<>
                                    <div className='col-md-12 row input-row'>
                                        <div className='col-md-6 client-details'>
                                            <div className='detail-title col-md-4'>{t('Client Id')}</div>
                                            <div className='details col-md-8'>{TaxFilingQuestionnaire.CustomerID}</div>
                                        </div>
                                    </div>

                                    <div className='col-md-12 row input-row'>
                                        <div className='col-md-6 client-details'>
                                            <div className='detail-title col-md-4'>{t('Client Name')}</div>
                                            <div className='details col-md-8'>{TaxFilingQuestionnaire.CustomerName}</div>
                                        </div>
                                    </div>

                                    <div className='col-md-12 row input-row'>
                                        <div className='col-md-6 client-details'>
                                            <div className='detail-title col-md-4'>{t('Date of birth')}</div>
                                            <div className='details col-md-8'>{TaxFilingQuestionnaire.DateOfBirth}</div>
                                        </div>
                                        <div className='col-md-6 client-details'>
                                            <div className='detail-title col-md-4'>{t('Marital status')}<i className='required'>*</i></div>
                                            <div className='details col-md-8'>
                                                <FormItem
                                                    name="MaritialStatus"
                                                    rules={[{ required: true, message: t('This field is required') }]}
                                                >
                                                    <select disabled={viewOnly}>
                                                        <option value=''>{t('Select Marital Status')}</option>
                                                        <option value='Single'>{t('Single')}</option>
                                                        <option value='Married'>{t('Married')}</option>
                                                        <option value='Divorced'>{t('Divorced')}</option>
                                                        <option value='Widowed'>{t('Widowed')}</option>
                                                    </select>
                                                </FormItem>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='col-md-12 row input-row'>
                                        <div className='col-md-6 client-details'>
                                            <div className='detail-title col-md-4'>{t('Mobile phone')}<i className='required'>*</i></div>
                                            <div className='details col-md-8'>
                                                <FormItem
                                                    name="PhoneNumber"
                                                    rules={[{ required: true, message: t('This field is required') }]}
                                                >
                                                    <CustomPhone inputRequired maxLength={15} />
                                                </FormItem>
                                            </div>
                                        </div>
                                        <div className='col-md-6 client-details'>
                                            <div className='detail-title col-md-4'>{t('Email address')}<i className='required'>*</i></div>
                                            <div className='details col-md-8'>
                                                <FormItem
                                                    name="Email"
                                                    rules={[{ required: true, type: 'email', message: t('This field is required') }]}
                                                >
                                                    <input disabled={viewOnly} type='text' />
                                                </FormItem>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='col-md-12 row input-row'>
                                        <div className='col-md-6 client-details'>
                                            <div className='detail-title col-md-4'>{t('Nationality')}<i className='required'>*</i></div>
                                            <div className='details col-md-8'>
                                                <FormItem
                                                    name="CountryOfNationality"
                                                    rules={[{ required: true, message: t('This field is required') }]}
                                                >
                                                    <select disabled={viewOnly}>
                                                        <option value=''>{t('Select Nationality')}</option>
                                                        {
                                                            Country != null && (<>
                                                                {
                                                                    Country?.map((item) => (<>
                                                                        <option value={item.name}>{item.name}</option>
                                                                    </>))
                                                                }
                                                            </>)
                                                        }
                                                    </select>
                                                </FormItem>
                                            </div>
                                        </div>

                                    </div>
                                    <div className='col-md-12 row input-row'>
                                        <div className='col-md-9 client-details'>
                                            <div className='detail-title col-md-8'>
                                                {t('VirtualCurrencyTradeInfo').replaceAll('{taxYear}', sessionStorage.getItem('taxYear'))}<i className='required'>*</i>
                                            </div>
                                            <div className='details col-md-4'>
                                                <FormItem
                                                    name="VirtualCurrencyTradeInfo"
                                                    rules={[{ required: true, message: t('This field is required') }]}
                                                >
                                                    <select disabled={viewOnly}>
                                                        <option value=''></option>
                                                        <option value='Yes'>{t('Yes')}</option>
                                                        <option value='No'>{t('No')}</option>
                                                    </select>
                                                </FormItem>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='col-md-12 row input-row'>
                                        <div className='col-md-9 client-details'>
                                            <div className='detail-title col-md-8'>
                                                {t('MoreThan250KFundReceived').replaceAll('{taxYear}', sessionStorage.getItem('taxYear'))}<i className='required'>*</i>
                                            </div>
                                            <div className='details col-md-4'>
                                                <FormItem
                                                    name="MoreThan250KFundReceived"
                                                    rules={[{ required: true, message: t('This field is required') }]}
                                                >
                                                    <select disabled={viewOnly}>
                                                        <option value=''></option>
                                                        <option value='Yes'>{t('Yes')}</option>
                                                        <option value='No'>{t('No')}</option>
                                                    </select>
                                                </FormItem>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='col-md-12 row input-row'>
                                        <div className='col-md-9 client-info-notes'>
                                            <svg
                                                className="svg-circle"
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="20"
                                                height="20"
                                                viewBox="0 0 20 20"
                                                fill="none"
                                            >
                                                <path
                                                    d="M10 20C4.48674 20 0 15.5054 0 9.97817C0 4.45098 4.48674 0 10 0C15.5133 0 20 4.47756 20 9.97817C20 15.4788 15.5133 20 10 20ZM10 1.84493C5.50189 1.84493 1.84091 5.49302 1.84091 9.97817C1.84091 14.4633 5.50189 18.1551 10 18.1551C14.4981 18.1551 18.1591 14.488 18.1591 9.97817C18.1591 5.46835 14.5 1.84493 10 1.84493Z"
                                                    fill="#003448"
                                                />
                                            </svg>
                                            <svg
                                                className="svg-exclamation"
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="2"
                                                height="10"
                                                viewBox="0 0 2 10"
                                                fill="none"
                                            >
                                                <path
                                                    d="M0.918557 9.50633C0.412028 9.50633 0 9.09255 0 8.58387V4.72129C0 4.21261 0.412028 3.79883 0.918557 3.79883C1.42509 3.79883 1.83711 4.21261 1.83711 4.72129V8.58387C1.83711 9.09255 1.42509 9.50633 0.918557 9.50633Z"
                                                    fill="#003448"
                                                />
                                                <path
                                                    d="M0.918557 2.89808C0.412028 2.89808 0 2.4843 0 1.97561V1.41758C0 0.908897 0.412028 0.495117 0.918557 0.495117C1.42509 0.495117 1.83711 0.908897 1.83711 1.41758V1.97561C1.83711 2.4843 1.42509 2.89808 0.918557 2.89808Z"
                                                    fill="#003448"
                                                />
                                            </svg>
                                            <span>{t('Please provide the Mailing Address in English.')}</span>
                                        </div>
                                    </div>

                                    <div className='col-md-12 row input-row'>
                                        <div className='col-md-9 client-details'>
                                            <div className='detail-title col-md-8'>{t('Mailing Address Line 1 (Street, House No./Apt No., Building)')}<i className='required'>*</i></div>
                                            <div className='details col-md-4'>
                                                <FormItem
                                                    name="TaxMailingAddressStreet"
                                                    rules={[{ required: true, message: t('This field is required') },
                                                    { pattern: TaxFilingQuestionnaire?.Status?.toLowerCase() === 'new' ? /^[A-Za-z0-9 ,.#()/-]{1,35}$/ : /^.*$/, message: t('Invalid input') }]}
                                                >
                                                    <textarea disabled={viewOnly} type='text' onChange={(e) => HandleTaxFilingQuestionnaireSave('TaxMailingAddressStreet', e.target.value)}></textarea>
                                                </FormItem>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='col-md-12 row input-row'>
                                        <div className='col-md-9 client-details'>
                                            <div className='detail-title col-md-8'>{t('Mailing Address Line 2 (City, District, Town, Post Office)')}<i className='required'>*</i></div>
                                            <div className='details col-md-4'>
                                                <FormItem
                                                    name="TaxMailingAddressCity"
                                                    rules={[{ required: true, message: t('This field is required') },
                                                    { pattern: TaxFilingQuestionnaire?.Status?.toLowerCase() === 'new' ? /^[A-Za-z0-9 ,.#()/-]{1,50}$/ : /^.*$/, message: t('Invalid input') }
                                                    ]}
                                                >
                                                    <textarea disabled={viewOnly} type='text' onChange={(e) => HandleTaxFilingQuestionnaireSave('TaxMailingAddressCity', e.target.value)}></textarea>
                                                </FormItem>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='col-md-12 row input-row'>
                                        <div className='col-md-9 client-details'>
                                            <div className='detail-title col-md-8'>{t('Province, State, and County')}</div>
                                            <div className='details col-md-4'>
                                                <FormItem
                                                    name="TaxMailingAddressState"
                                                    rules={[{ required: false, message: t('This field is required') }]}
                                                >
                                                    <input disabled={viewOnly} type='text' onChange={(e) => HandleTaxFilingQuestionnaireSave('TaxMailingAddressState', e.target.value)} />
                                                </FormItem>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='col-md-12 row input-row'>
                                        <div className='col-md-9 client-details'>
                                            <div className='detail-title col-md-8'>{t('Country')}<i className='required'>*</i></div>
                                            <div className='details col-md-4'>
                                                <FormItem
                                                    name="TaxMailingCountry"
                                                    rules={[{ required: true, message: t('This field is required') }]}
                                                >
                                                    <select disabled={viewOnly} onChange={(e) => HandleTaxFilingQuestionnaireSave('TaxMailingCountry', e.target.value)}>
                                                        <option value=''>{t('Select Country')}</option>
                                                        {
                                                            Country != null && (<>
                                                                {
                                                                    Country?.map((item) => (<>
                                                                        <option value={item.name}>{item.name}</option>
                                                                    </>))
                                                                }
                                                            </>)
                                                        }
                                                    </select>
                                                </FormItem>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='col-md-12 row input-row'>
                                        <div className='col-md-9 client-details'>
                                            <div className='detail-title col-md-8'>{t('ZIP/Postal Code')}</div>
                                            <div className='details col-md-4'>
                                                <FormItem
                                                    name="TaxMailingAddressZipcode"
                                                    rules={[{ required: false, message: t('This field is required') },
                                                    {
                                                        attern: /^[a-zA-Z0-9\s-]*$/, message: t('Invalid Postal Code')
                                                    },
                                                    {
                                                        max: 10,
                                                        message: t('Invalid Postal Code')
                                                    }]}
                                                >
                                                    <input disabled={viewOnly} type='text' onChange={(e) => HandleTaxFilingQuestionnaireSave('TaxMailingAddressZipcode', e.target.value)} />
                                                </FormItem>
                                            </div>
                                        </div>
                                    </div>
                                </>)}
                        </>)}

                    {
                        (TaxFilingQuestionnaire.CountryOfTaxResidency === 'USA' || TaxFilingQuestionnaire.OtherUSIncomeSource === 'Yes') && (<>
                            <div className='col-md-12 row input-row'>
                                <div className='col-md-12 us-tax-resident-icons'>
                                    <svg
                                        className="svg-circle"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="20"
                                        height="20"
                                        viewBox="0 0 20 20"
                                        fill="none"
                                    >
                                        <path
                                            d="M10 20C4.48674 20 0 15.5054 0 9.97817C0 4.45098 4.48674 0 10 0C15.5133 0 20 4.47756 20 9.97817C20 15.4788 15.5133 20 10 20ZM10 1.84493C5.50189 1.84493 1.84091 5.49302 1.84091 9.97817C1.84091 14.4633 5.50189 18.1551 10 18.1551C14.4981 18.1551 18.1591 14.488 18.1591 9.97817C18.1591 5.46835 14.5 1.84493 10 1.84493Z"
                                            fill="#dd0606"
                                        />
                                    </svg>
                                    <svg
                                        className="svg-exclamation"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="2"
                                        height="10"
                                        viewBox="0 0 2 10"
                                        fill="none"
                                    >
                                        <path
                                            d="M0.918557 9.50633C0.412028 9.50633 0 9.09255 0 8.58387V4.72129C0 4.21261 0.412028 3.79883 0.918557 3.79883C1.42509 3.79883 1.83711 4.21261 1.83711 4.72129V8.58387C1.83711 9.09255 1.42509 9.50633 0.918557 9.50633Z"
                                            fill="#dd0606"
                                        />
                                        <path
                                            d="M0.918557 2.89808C0.412028 2.89808 0 2.4843 0 1.97561V1.41758C0 0.908897 0.412028 0.495117 0.918557 0.495117C1.42509 0.495117 1.83711 0.908897 1.83711 1.41758V1.97561C1.83711 2.4843 1.42509 2.89808 0.918557 2.89808Z"
                                            fill="#dd0606"
                                        />
                                    </svg>
                                </div>
                                <div className='us-tax-resident-notes'>
                                    <span>
                                        {t('You are not eligible to proceed with AAS services, which are for non-U.S. tax residents only.')}
                                    </span>
                                </div>
                            </div>
                        </>)
                    }
                </div>
            </div>
        </>
    );
}